var _path, _path2, _path3, _circle, _circle2, _circle3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwiftpredict = function SvgSwiftpredict(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M14.066 20.675c.434-1.414 2.434-1.414 2.868 0l2.676 8.721a1.5 1.5 0 0 0 .994.994l8.722 2.676c1.413.434 1.413 2.434 0 2.868l-8.722 2.676a1.5 1.5 0 0 0-.994.994l-2.676 8.721c-.434 1.414-2.434 1.414-2.868 0l-2.676-8.721a1.5 1.5 0 0 0-.994-.994l-8.721-2.676C.26 35.5.26 33.5 1.675 33.066l8.721-2.676a1.5 1.5 0 0 0 .994-.994z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    d: "M29.066 6.675c.434-1.414 2.434-1.414 2.868 0l.798 2.6a1.5 1.5 0 0 0 .994.993l2.6.798c1.413.434 1.413 2.434 0 2.868l-2.6.798a1.5 1.5 0 0 0-.994.994l-.798 2.6c-.434 1.413-2.434 1.413-2.868 0l-.798-2.6a1.5 1.5 0 0 0-.994-.994l-2.6-.798c-1.413-.434-1.413-2.434 0-2.868l2.6-.798a1.5 1.5 0 0 0 .994-.994z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    d: "M23.85 55.79c.11-1.418 2.19-1.418 2.3 0a1.15 1.15 0 0 0 1.06 1.06c1.418.11 1.418 2.19 0 2.3a1.15 1.15 0 0 0-1.06 1.06c-.11 1.418-2.19 1.418-2.3 0a1.15 1.15 0 0 0-1.06-1.06c-1.418-.11-1.418-2.19 0-2.3a1.15 1.15 0 0 0 1.06-1.06"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 46,
    r: 7,
    fill: "#FF9D43"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 60,
    r: 4,
    fill: "#6C9BF1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.766,
    cy: 18.475,
    r: 10.796,
    fill: "#2F68D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FDFDFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m49.239 18.95 3.316 3.316 6.158-6.158"
  })));
};
export default SvgSwiftpredict;